<template>
	<Dialog v-bind:value="value" @input="$emit('input', $event)"
					width="600px"
					title="Modul löschen ?"
					:loading="loading"
					@ok="submit" ok-text="Löschen"
					@cancel="close" @click:outside="close">
		Soll das Modul <b>{{ selected ? selected.Name : null }}</b>
		wirklich gelöscht werden?
		<v-alert dense type="warning" class="mt-4">
			Achtung: Diese Aktion nur durchführen, wenn z.B. eine Umbennung im Git erfolgt oder aber das Modul nicht
			mehr verwendet werden soll.
		</v-alert>
	</Dialog>
</template>

<script>
import Dialog from "../../../components/Dialog";

export default {
	name: "DeleteModuleDialog",
	components: {Dialog},
	props: ['value'],
	data: () => {
		return {
			loading: false,
		}
	},
	computed: {
		selected() {
			return this.$store.state.settings.selectedItem;
		}
	},
	methods: {
		async submit() {
			this.loading = true;
			let data;
			try {
				data = await this.$store.dispatch('settings/deleteModule', {module_id: this.selected.ModuleId});
				this.loading = false;
				if (data.Status) {
					this.$root.$emit('snackbar', this.selected.Name + ' erfolgreich gelöscht.');
					this.$emit('input', false); // set v-model to false -> close dialog
					this.$emit('deleted');
				}
			} catch (e) {
				this.loading = false;
			}
		},
		close() {
			this.$store.commit('settings/resetSelected');
			this.$emit('input', false);
		}
	}
}
</script>

<style scoped>

</style>